import { render, staticRenderFns } from "./Mandate.vue?vue&type=template&id=5657384d&scoped=true&"
import script from "./Mandate.vue?vue&type=script&lang=js&"
export * from "./Mandate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5657384d",
  null
  
)

export default component.exports